import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const includes = ['Teoría clara y secuenciada adaptada al nivel secundario argentino', 'Actividades de menor a mayor complejidad con espacios de resolución', 'Rúbricas de evaluación por actividad con criterios claros', 'Modelos de partículas, diagramas e infografías en color', 'Experiencias de laboratorio con guías y fichas de registro', 'Proyectos integradores por unidad', 'Glosario y bibliografía en cada cuadernillo'];
export function IncludesSection() {
  return <section className="py-20 px-4 bg-brand-light" data-id="element-201">
      <div className="max-w-4xl mx-auto" data-id="element-202">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-203">
          Cada cuadernillo incluye:
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl mb-12" data-id="element-204">
          <ul className="space-y-6" data-id="element-205">
            {includes.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-206">
                <div className="bg-brand-green/10 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-207">
                  <CheckIcon className="w-6 h-6 text-brand-green" strokeWidth={3} data-id="element-208" />
                </div>
                <span className="text-xl font-medium text-gray-800" data-id="element-209">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-210">
          <CTAButton text="→ QUIERO TODO ESTO AHORA" href="#compra" data-id="element-211" />
        </div>
      </div>
    </section>;
}